import { CardTransferTemplate } from "@/modules/template/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const CardTransferTemplatePage = ({ isEdit }: IOperationPageProps) => (
  <CardTransferTemplate isEdit={isEdit}/>
);
